var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.$style.linkBack,on:{"click":function($event){_vm.path ? _vm.$router.push(_vm.path) : _vm.$router.back()}}},[_c('rekroo-icon',{staticStyle:{"margin-right":"10px"},attrs:{"icon":"chevron-left","color":"var(--gray-text)","width":"var(--small-text)"}}),_vm._v(" "+_vm._s(_vm.text))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }